import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
  transform(value: unknown, firstNameProperty = 'firstName', lastNameProperty = 'lastName'): string {
    if (typeof value !== 'object' || value === null) return '';
    const firstName = (value[firstNameProperty as keyof typeof value] as string) || '';
    const lastName = (value[lastNameProperty as keyof typeof value] as string) || '';
    return `${firstName} ${lastName}`.trim();
  }
}
